<template>
  <v-content>
    <v-container fluid>
      <v-layout
        class="my-5"
        justify-center>
        <h1>Site Management System</h1>
      </v-layout>
      <v-layout justify-center>
        <v-btn
          :href="url"
          color="green darken-3">
          Please log in
        </v-btn>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "login",
  computed: {
    url () {
      const { host } = window.location;
      let module = "";
      switch (host) {
      case "sms.thinxtra.com":
        module = "?externalModule=sms";
        break;
      case "staging.sms.thinxtra.com":
        module = "?externalModule=staging-sms";
        break;
      default:
        module = "";
      }
      // eslint-disable-next-line prefer-template
      return "https://auth.thinxtra.com/" +
             "auth/google" + module;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue